export const DIALOG_SHIPMENT_TRACKING_DETAILS = 'shipment-tracking-details'
